import Vue from "vue";
import Vuex from "vuex";
import router from "@/router/index.js";
import { getUserMenu, getUserMenuAdmin } from "@/request/api";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    tableId: "",
    initiator: false, //发起人弹窗
    initiatorData: {},
    audit: false, //审核人弹窗
    auditData: {},
    make: false, //办理人弹窗
    makeData: {},
    condition: false, //条件弹窗
    conditionData: {},
    merge: false, //合并弹窗
    mergeData: {},
    flow: false, //流程弹窗
    flowData: {},
    isCollapse: false, //收起菜单
    allRequiredList: [], // 条件
    formConfigPropertiesVOList: [], //表单
    userMenu: [], //菜单
    userMenuAdmin: [], //菜单
    initiatorList: {}, //基础设置的发起人
    formContacts: [], //表单联系人
    verify: false, //校验
    notifier: false, //抄送人
    notifierData: {},
    filing: false, //归档人
    filingData: {},
    connector: false,  //连接器
    connectorData: {}
  },
  getters: {},
  mutations: {
    // 审批id
    setTableId(status, payload) {
      status.tableId = payload;
    },
    // 发起人弹窗
    setInitiator(state, val) {
      state.initiator = val;
    },
    // 发起人弹窗数据
    setInitiatorData(state, val) {
      state.initiatorData = val;
    },
    // 审核人弹窗
    setAudit(state, val) {
      state.audit = val;
    },
    // 审核人弹窗数据
    setAuditData(state, val) {
      state.auditData = val;
    },
    // 办理人弹窗
    setMake(state, val) {
      state.make = val;
    },
    // 办理人弹窗数据
    setMakeData(state, val) {
      state.makeData = val;
    },
    // 条件弹窗
    setCondition(state, val) {
      state.condition = val;
    },
    // 条件弹窗数据
    setConditionData(state, val) {
      state.conditionData = val;
    },
    // 合并弹窗
    setMerge(state, val) {
      state.merge = val;
    },
    // 合并弹窗数据
    setMergeData(state, val) {
      state.mergeData = val;
    },
    // 流程弹窗
    setFlow(state, val) {
      state.flow = val;
    },
    // 流程数据弹窗
    setFlowData(state, val) {
      state.flowData = val;
    },
    // 收起菜单
    changeIsCollapse(state, val) {
      state.isCollapse = val;
    },
    // 条件
    setAllRequiredList(state, val) {
      state.allRequiredList = val;
    },
    // 表单
    setFormConfigPropertiesVOList(state, val) {
      state.formConfigPropertiesVOList = val;
    },
    // 获取菜单
    updataUserMenu(state, val) {
      state.userMenu = val;
    },
    updataUserMenuAdmin(state, val) {
      state.userMenu = val;
    },
    // 基础设置发起人
    setInitiatorList(state, val) {
      state.initiatorList = val;
    },
    // 获取表单联系人
    setFormContacts(state, val) {
      state.formContacts = val;
    },
    // 校验
    setVerify(state, val) {
      state.verify = val;
    },
    // 抄送人弹窗
    setNotifier(state, val) {
      state.notifier = val;
    },
    // 抄送人数据弹窗
    setNotifierData(state, val) {
      state.notifierData = val;
    },
    // 归档人弹窗
    setFiling(state, val) {
      state.filing = val;
    },
    // 归档人数据弹窗
    setFilingData(state, val) {
      state.filingData = val;
    },
    // 连接器弹窗
    setConnector(state, val) {
      state.connector = val;
    },
    // 连接器数据弹窗
    setConnectorData(state, val) {
      state.connectorData = val;
    },
  },
  actions: {
    // 获取菜单
    UserMenu({ commit }) {
      return new Promise((resolve, reject) => {
        getUserMenu().then((res) => {
          if (res) {
            if (res.code == 200) {
              // commit("clearUserMenu")
              console.info(res.data);
              commit("updataUserMenu", res.data);
              resolve();
            } else {
              if (res.code > -40001 && res.code < -40005) {
                let userType = sessionStorage.getItem("userType");
                if (userType == "sysUser") {
                  router.replace("/login");
                }
                if (userType == "user" || userType == "userLogin") {
                  router.replace("/user/login");
                }
                sessionStorage.clear();
                commit("updataUserMenu", []);
                localStorage.clear();
                reject();
              } else {
                commit("updataUserMenu", res.data);
                resolve();
              }
            }
          }
        });
      });
    },
    // 获取平台菜单
    UserMenuAdmin({ commit }) {
      return new Promise((resolve, reject) => {
        getUserMenuAdmin().then((res) => {
          console.log('getUserMenuAdmin: ', res);
          if (res) {
            if (res.code == 200) {
              // commit("clearUserMenu")
              commit("updataUserMenu", res.data);
              resolve();
            } else {
              if (res.code > -40001 && res.code < -40005) {
                let userType = sessionStorage.getItem("userType");
                if (userType == "sysUser") {
                  router.replace("/login");
                }
                if (userType == "user" || userType == "userLogin") {
                  router.replace("/user/login");
                }
                sessionStorage.clear();
                commit("updataUserMenu", []);
                localStorage.clear();
                reject();
              } else {
                commit("updataUserMenu", res.data);
                resolve();
              }
            }
          }
        });
      });
    },
  },
  modules: {},
});
